import './auditHistory.styles.css'

import {
  CheckOutlined,
  ClockCircleFilled,
  ClockCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
  SafetyCertificateOutlined,
  SwitcherOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { MaterialIcon, Texto } from '@gravitate-js/excalibrr'

import AssignIcon from '../assets/CustomIcons/assign.svg'
import LinkIcon from '../assets/CustomIcons/link.svg'
import LockIcon from '../assets/CustomIcons/lock.svg'
import UnlockIcon from '../assets/CustomIcons/unlock.svg'
import ModelGenIcon from '../assets/CustomIcons/modelGenIcon.svg'
import CompletedIcon from '../assets/CustomIcons/orderStatusIcons/completedIcon.svg'
import ProductIcon from '../assets/CustomIcons/product_change.svg'
import ResetIcon from '../assets/CustomIcons/resetIcon.svg'
import SentIcon from '../assets/CustomIcons/sentIcon.svg'
import SupplyIcon from '../assets/CustomIcons/supplyIcon.svg'
import UserIcon from '../assets/CustomIcons/user_edited.svg'

export const auditActions = {
  create: 'Order Created',
  update: 'Order Updated',
  'movement validation bypass was created': 'Movement Errors Bypassed',
  'movement validation bypass was cleared': 'Movement Errors Bypass Cleared',
  'update destination': 'Destination Updated',
  'update supply option': 'Supply Option Changed',
  'update carrier window': 'Carrier Window Changed',
  'update volume': 'Volume Updated',
  update_lock: 'Lock Updated',
  reset: 'Order Reset',
  assign: 'Assigned to Driver',
  move: 'Changed Driver',
  remove: 'Removed from Driver',
  link: 'Order Linked',
  unlink: 'Order Unlinked',
  'carrier assign': 'Assigned to Carrier',
  'carrier unassign': 'Unassigned from Carrier',
  'carrier send email': 'Carrier Email Sent',
  'carrier mark sent': 'Carrier Marked As Sent',
  'carrier accept': 'Carrier Accepted',
  'carrier reject': 'Carrier Rejected',
  'carrier completed': 'Completed By Carrier',
  uncomplete: 'Carrier Un-completed',
  'update product': 'Product Updated',
  'smart supply': 'Smart Supply Updated',
  'smart supply v2': 'Smart Supply',
  'order staged': 'Order Staged',
  'order unstaged': 'Order Unstaged',
  cancel: 'Order Canceled',
  'driver drop override': 'Driver Drop Override',
  'driver volume override': 'Driver Volume Override',
  'driver supplier override': 'Driver Supplier Override',
  'supply lock': 'Supply Locked',
  'supply unlock': 'Supply Unlocked',

  // Delivery Rec Audit Actions
  created: 'Created',
  approved: 'Approved',
  unapproved: 'Unapproved',
  delivery_added: 'Delivery Added',
  delivery_removed: 'Delivery Removed',
  order_added: 'Order Added',
  order_removed: 'Order Removed',
}

export const actionIcons = {
  created_by_model: <img src={ModelGenIcon} />,
  created_by_user: <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  update: <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'update destination': <img src={AssignIcon} />,
  'update supply option': <img src={SupplyIcon} />,
  'update product': <img src={ProductIcon} />,
  'movement validation bypass was created': <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'movement validation bypass was cleared': <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'update volume': <img src={ProductIcon} />,
  // I know this looks funky, but we can't use img tags with antd React icon components.
  'update carrier window': (
    <Texto style={{ fontSize: 30, color: 'var(--theme-color-2)' }}>
      <ClockCircleFilled />
    </Texto>
  ),
  update_lock: <img src={LockIcon} />,
  reset: <img src={ResetIcon} />,
  assign: <img src={AssignIcon} />,
  move: <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  remove: <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  link: <img src={LinkIcon} />,
  unlink: <img src={LinkIcon} />,
  'carrier assign': <img src={AssignIcon} />,
  'carrier unassign': <img src={AssignIcon} />,
  'carrier send email': <img src={SentIcon} />,
  'carrier mark sent': <img src={SentIcon} />,
  'carrier accept': 'Carrier Accepted',
  'carrier reject': 'Carrier Rejected',
  'carrier completed': <img src={CompletedIcon} />,
  uncomplete: 'Carrier Un-completed',
  'smart supply': <img src={SupplyIcon} />,
  'smart supply v2': <img src={SupplyIcon} />,
  'order staged': (
    <div className='history-item'>
      <SafetyCertificateOutlined />
    </div>
  ),
  'order unstaged': (
    <div className='history-item'>
      <SwitcherOutlined />
    </div>
  ),
  cancel: (
    <div className='history-item'>
      <DeleteOutlined />
    </div>
  ),
  'driver drop override': <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'driver volume override': <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'driver supplier override': <img src={UserIcon} style={{ width: 30, height: 30 }} />,
  'supply lock': <img src={LockIcon} />,
  'supply unlock': <img src={UnlockIcon} />,
  delivery_added: (
    <div className='history-item'>
      <MaterialIcon icon='opacity' size={16} style={{ paddingTop: '3px' }} />
    </div>
  ),
  delivery_removed: (
    <div className='history-item'>
      <MaterialIcon icon='opacity' size={16} style={{ paddingTop: '3px' }} />
    </div>
  ),
  order_added: (
    <div className='history-item'>
      <MaterialIcon icon='description' size={16} style={{ paddingTop: '3px' }} />
    </div>
  ),
  order_removed: (
    <div className='history-item'>
      <MaterialIcon icon='description' size={16} style={{ paddingTop: '3px' }} />
    </div>
  ),
  created: (
    <div className='history-item'>
      <PlusOutlined />
    </div>
  ),
  approved: (
    <div className='history-item'>
      <CheckOutlined />
    </div>
  ),
  unapproved: (
    <div className='history-item'>
      <WarningOutlined />
    </div>
  ),
}
